import BaseNormalizer from "./BaseNormalizer";

const merchantStoreCoordinatesNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "name",
  "latitude",
  "longitude",
]);

export default merchantStoreCoordinatesNormalizer;
